
interface IUserConfig
{
    /**
     * Login do usuário (login1)
     * @example
     * ```json
     * {
     * ...
     * usuario: "brs-y00000xxx"
     * }
     * ```
     */
    usuario: string;
    /**
     * Nome do shopping (nomEmpresa)
     * @example
     * ```json
     * {
     * ...
     * shoppingTexto: "BarraShopping"
     * }
     * ```
     */
    shoppingTexto: string;
    /**
     * Id do shopping (idEmpresa)
     * @example
     * ```json
     * {
     * ...
     * shoppingCod: "BRS"
     * }
     * ```
     */
    shoppingCod: string;
    /**
     * Nome da loja do usuário (nomContrato)
     * @example
     * ```json
     * {
     * ...
     * loja: "XPTO Lanches"
     * }
     * ```
     */
    loja: string;
    /**
     * Número do contrato (numContrato)
     * @example
     * ```json
     * {
     * ...
     * numContrato: "y00000xxx"
     * }
     * ```
     */
    numContrato: string;
    /**
     * Tipo do usuário 1 - Multiplan, 2 - Lojista Master, 3 - Lojista Funcionário (idTipoUsuario)
     * @example 2 -> Master
     */
    tipoUsuario: number;
    /**
     * Nome do usuário (nomUsuario)
     * @example
     * "nomeUsuario": "Eric XPTO"
     */
    nomeUsuario: string;
    /**
     * Data de expiração do token (dataToken)
     * @example
     * "dataToken": "2019-12-31T23:59:59"
     */
    dataToken: string;
    token: string;
    /**
     * Devolve as iniciais do usuário
     * @example
     * ```json
     * {
     * ...
     * nomeUsuario: "Eric XPTO"
     * }
     * ```
     *
     * getIniciais() -> "EX"
     */
    getIniciais(): string;

}
export class UserConfigDto implements IUserConfig {

    usuario: string = '';
    shoppingTexto: string = '';
    shoppingCod: string = '';
    loja: string = '';
    numContrato: string = '';
    tipoUsuario: number = null;
    nomeUsuario: string = '';

    dataToken: string = null;
    token: string = '';

    constructor(object: any) {
        if(!object) return;

        Object.assign(this, object);
    }

    get idEmpresa(): string {
        return this.shoppingCod;
    }

    get nomEmpresa(): string {
        return this.shoppingTexto;
    }

    get nomContrato(): string {
        return this.loja;
    }
    get isUsuarioMultiplan(): boolean {
        return this.tipoUsuario == 1;
    }
    get isUsuarioLojistaMaster(): boolean {
        return this.tipoUsuario == 2;
    }

    get isUsuarioLojistaFuncionario(): boolean {
        return this.tipoUsuario == 3;
    }

    getIniciais() : string {
        let iniciais : string = "";
        let split : string[];

        let usuName = this.nomeUsuario;

        // if(this.tipoUsuario == 1)
        // {
        //     usuName = this.usuario;
        // }
        // else if(this.tipoUsuario == 2)
        // {
        //     usuName = this.loja;
        // }
        // else if(this.tipoUsuario == 3)
        // {

        // }

        if(usuName.startsWith("lj_"))
        {
            usuName = usuName.replace("lj_", "");

        }

        split = usuName.split(" ");

        if(split.length == 1)
        {
            if(usuName.length <= 3) {
                return usuName;
            }
        }

        for(let i = 0; i < split.length; i++) {
            if(split[i] == "" || split[i] == " ") {
                continue;
            }

            iniciais += split[i][0];

            if(iniciais.length == 2) {
                break;
            }
        }

        return iniciais;
    }
}
